module.exports = __webpack_public_path__ + "static/homepage-hero-tvc-landscape-1200w-f6944af24cd51f20fdca0d446f59d152.jpg";